export const GALLERY_MODAL_ID = 'galleryModal';
export const GUEST_SELECT_MODAL_ID = 'guestSelectModal';
export const REVIEWS_MODAL_ID = 'reviewsModal';
export const DETAILS_MODAL_ID = 'detailsModal';
export const FACILITY_MAP_MODAL_ID = 'facilityMapModal';
export const PAYMENT_DETAILS_MODAL_ID = 'paymentDetails';
export const UNIT_MODAL_ID = 'unitModal';
export const LOGIN_MODAL_ID = 'loginModal';
export const SOCIAL_SHARE_MODAL_ID = 'socialShareModal';
export const RESERVATION_MOBILE_MODAL_ID = 'reservationMobileModal';
export const CHECKOUT_SECURITY_MODAL_ID = 'checkoutSecurityModal';
export const ACCOMMODATION_TERMS_MODAL_ID = 'accommodationTermsModal';
export const PRIVACY_POLICY_MODAL_ID = 'privacyPolicyModal';
export const FACILITY_UNIT_DESCRIPTION_MODAL_ID = 'facilityUnitDescriptionModal';
export const WISHLIST_CONFIRMATION_MODAL_ID = 'wishlistConfirmationModal';
export const WISHLIST_MODAL_ID = 'wishlistModal';
export const WISHLIST_GUESTS_MODAL_ID = 'wishlistGuestsModal';
export const WISHLIST_DATES_MODAL_ID = 'wishlistDatesModal';
export const WISHLIST_LOCATION_MODAL_ID = 'wishlistLocationModal';
export const SEARCH_FILTERS_MODAL_ID = 'searchFiltersModal';
export const LANGUAGE_SELECT_MODAL_ID = 'languageSelectModal';
export const USER_MENU_ID = 'userMenu';
export const QUICK_SEARCH_DOCK_ID = 'quickSearchDock';
export const QUICK_SEARCH_MODAL_ID = 'quickSearchModal';
export const QUICK_SEARCH_MODAL_DOCK_ID = 'quickSearchModalDock';
export const QUICK_SEARCH_MODAL_LOCATION_ID = 'quickSearchModalLocation';
export const QUICK_SEARCH_MODAL_DOCK_LOCATION_ID = 'quickSearchModalDockLocation';
export const SEARCH_MAP_ID = 'searchMap';
export const OUR_DEPARTMENT_MODAL_ID = 'ourDepartmentModal';
export const AI_SEARCH_MODAL_ID = 'AISearchModal';
export const PRIVATE_DATA_CONSENT_MODAL_ID = 'privateDataConsentModal';
export const ADDITIONAL_FORM_DATE_RANGE_PICKER_ID = 'additionalFormDateRangePicker';
export const BANNER_EMBED_MODAL_ID = 'bannerEmbedModal';

// Popis modala koji se mogu otvoriti direktno preko linka.
export const DEEP_LINKABLE_MODALS = new Set(
    [
        GALLERY_MODAL_ID,
        REVIEWS_MODAL_ID,
        DETAILS_MODAL_ID,
        FACILITY_MAP_MODAL_ID,
        SOCIAL_SHARE_MODAL_ID,
    ],
);

export const CHECKOUT_MODALS = new Set([
    CHECKOUT_SECURITY_MODAL_ID,
    ACCOMMODATION_TERMS_MODAL_ID,
    PRIVACY_POLICY_MODAL_ID,
]);
